import axios from 'axios';

const API_ROOT = process.env.REACT_APP_API_BASE_URL;

export const createListAPI = (resourcePath) => {
  const BASE = `${API_ROOT}${resourcePath}`;
  return {
    create: (data) => axios.post(`${BASE}/create`, data),
    getById: (id) => axios.get(`${BASE}/get/${id}`),
    getAll: (config) => axios.get(`${BASE}/getall`, config).then(r => r.data),
    update: (id, data) => axios.put(`${BASE}/modify/${id}`, data),
    remove: (id) => axios.delete(`${BASE}/delete/${id}`),
  };
};

export const DeliveryModeAPI = createListAPI('/lists/delivery-mode');
export const PaymentModeAPI = createListAPI('/lists/payment-mode');
export const CountryAPI = createListAPI('/lists/country');
export const CityAPI = createListAPI('/lists/city');
export const BankAPI = createListAPI('/lists/bank');


